import React from 'react';
import PropTypes from 'prop-types';
import { Body, Name, StyledEndorsement, BodyContainer } from './styles';

export const Endorsement = ({ body, name, typography, fontColor }) => {
  return (
    <StyledEndorsement>
      <BodyContainer>
        <Body $typography={typography} $fontColor={fontColor}>
          {body}
        </Body>
      </BodyContainer>
      <Name $fontColor={fontColor}>{name}</Name>
    </StyledEndorsement>
  );
};

Endorsement.displayName = 'Endorsement';

Endorsement.propTypes = {
  body: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  typography: PropTypes.string,
  fontColor: PropTypes.string,
};
